import template from './registration.html'

let component = {
  restrict: 'E',
  template
}

export default component



// WEBPACK FOOTER //
// ./src/app/pages/registration/registration.component.js